import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../service/auth.service';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token = this.authService.getUser();

    if (!token || this.authService.isTokenExpired()) {
      sessionStorage.setItem('redirectUrl', state.url);
      this.router.navigate(['/login']);
      return false;
    }
    const requiredAuthorities = route.data['authorities'] as string[];

    if (requiredAuthorities && requiredAuthorities.length > 0) {
      const hasAuthority = requiredAuthorities.some(auth =>
        this.authService.hasAuthority(auth)
      );

      if (!hasAuthority) {
        this.router.navigate(['/unauthorized']);
        return false;
      }
    }
    return true;
  }
}
